import { render } from "./PaymentsSummaryCard.vue?vue&type=template&id=46e38ecb&scoped=true&ts=true"
import script from "./PaymentsSummaryCard.vue?vue&type=script&lang=ts"
export * from "./PaymentsSummaryCard.vue?vue&type=script&lang=ts"

import "./PaymentsSummaryCard.vue?vue&type=style&index=0&id=46e38ecb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e38ecb"]])

export default __exports__